import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface BreadcrumbState {
  platformUser: { id: number; name: string } | null;
  starterName: string | null;
  activityName: string | null;
  evidenceName: string | null;
}

const initialState: BreadcrumbState = {
  platformUser: null,
  starterName: null,
  activityName: null,
  evidenceName: null,
};

const breadcrumbSlice = createSlice({
  name: "breadcrumb",
  initialState,
  reducers: {
    setBreadcrumbState: (
      state,
      action: PayloadAction<Partial<BreadcrumbState>>
    ) => {
      return { ...state, ...action.payload };
    },
    clearBreadcrumbState: () => initialState,
  },
});

export const { setBreadcrumbState, clearBreadcrumbState } =
  breadcrumbSlice.actions;
export default breadcrumbSlice.reducer;
